import { Tab, Tabs } from '@material-ui/core';
import styled from 'styled-components';

export const GaugeWrapper = styled.div`
  width: 100%;
  margin: 1rem 0rem 3rem 0rem;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  svg {
    g:nth-child(3) {
      transform: translate(150, 90) !important;

      text.current-value {
        transform: translate(0px, -60px) !important;
        font-size: 22px !important;
      }
    }
  }

  g.arc {
    path.speedo-segment:nth-child(1) {
      d: path(
        'M-100.55925339811357,-3.4253146373998824A6,6,0,0,1,-106.53307043166485,-9.985234318829578A107,107,0,0,1,-61.91400179867905,-87.26772817756382A6,6,0,0,1,-53.24603619099976,-85.37421070966305L-48.52330645603068,-77.19420285828033A6,6,0,0,1,-50.20071703078508,-69.33432057498685A85.60000000000001,85.60000000000001,0,0,0,-85.14564148746524,-8.807935949360594A6,6,0,0,1,-91.11379392817543,-3.4253146373998717Z'
      );
    }
    path.speedo-segment:nth-child(2) {
      d: path(
        'M-47.31321720711382,-88.79952534706291A6,6,0,0,1,-44.61906863298584,-97.25296249639338A107,107,0,0,1,56.931405192232845,-90.59699279136036A6,6,0,0,1,58.49910998955599,-81.86421901405419L52.7490785849925,-74.37063219299328A6,6,0,0,1,44.84557697927707,-72.91251076047057A85.60000000000001,85.60000000000001,0,0,0,-34.944924456680184,-78.14225652434742A6,6,0,0,1,-42.59048747214477,-80.61951749568018Z'
      );
    }
    path.speedo-segment:nth-child(3) {
      d: path(
        'M63.934079607815306,-77.69382014711812A6,6,0,0,1,72.7750431931011,-78.43974176552514A107,107,0,0,1,106.53307043166487,-9.985234318829583A6,6,0,0,1,100.55925339811357,-3.425314637399886L91.11379392817543,-3.4253146373998824A6,6,0,0,1,85.14564148746524,-8.807935949360589A85.60000000000001,85.60000000000001,0,0,0,58.821187792270024,-62.188647410170496A6,6,0,0,1,58.18404820325182,-70.20023332605722Z'
      );
    }
  }

  > div > label {
    display: block;
    width: 100%;
    min-height: 16px;
    font-size: 14px;
    color: rgb(135, 134, 139);
    margin-bottom: 8px;
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const Box = styled.div`
  width: 100%;
  border: 1px solid #eceeef;

  display: flex;
  justify-content: center;
  align-items: center;

  padding-bottom: 1rem;

  > div {
    position: relative;

    .min,
    .max {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      position: absolute;
      bottom: 24px;
    }

    .max {
      justify-content: flex-end;
    }

    .media {
      width: 100%;
      display: flex;
      justify-content: center;
      position: absolute;
      bottom: 16px;
    }
  }
`;

export const TabBase = styled(Tab)``;

export const WrapperTab = styled.section`
  /* div[role='tabpanel'] {
    .MuiBox-root.MuiBox-root-8 {
      padding: 0px !important;
    }
  } */
`;

export const TabsBase = styled(Tabs)`
  padding: 0;

  > div > div {
    border-bottom: 2px solid #ccc;
  }

  .MuiTab-textColorInherit.Mui-selected {
    background: #166649;
    color: white;
    border-radius: 4px 4px 0 0;
    transition: 0.3s ease-in-out;
  }

  .MuiTab-textColorInherit {
    background: #ccc;
    border-radius: 4px 4px 0 0;
    margin-right: 0.5rem;
    transition: 0.3s ease-in-out;
  }

  .PrivateTabIndicator-colorSecondary-3,
  .MuiTabs-indicator {
    background-color: #ab934b;
  }
`;
